module.exports = __webpack_public_path__ + "static/media/arrow.3887e588.svg";